module.exports = __webpack_public_path__ + "img/user_banner@2x.2ba56865.jpg";